import { ReactComponent } from "./time-line.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const TimeLineIcon: React.FC<Props> = (Props) => <ReactComponent {...Props} />;

export default TimeLineIcon;
